let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aOUf8")).then(() => parcelRequire('7MdHb'));